import React, {Fragment} from 'react';
import Navbar from '../../components/Navbar/Navbar';
import PageTitle from '../../components/pagetitle/PageTitle'
import Scrollbar from '../../components/scrollbar/scrollbar'
import ProjectSectionS2 from '../../components/ProjectSectionS2/ProjectSectionS2';
import Footer from '../../components/footer/Footer';


const ProjectPage =() => {
    function hideShowClases(id){
        var classEleList = document.getElementsByClassName("current");
        if(classEleList.length !== 0)
        {
            classEleList[0].classList.remove("current");
        }
        const el = document.getElementById(id);
if (el) {
  el.classList.add("current");
}
    }
    hideShowClases("home_project");
    return(
        <Fragment>
            <div id="notification" class="notification"></div>
            <Navbar name="project"/>
            <PageTitle pageTitle={'Projects'} pagesub={'Project'}/> 
            <ProjectSectionS2/>
            <Footer/>
            <Scrollbar/>
        </Fragment>
    )
};
export default ProjectPage;
